module.exports = __webpack_public_path__ + "media/images/badge/fenomeno-cdd8258067e6a85416df8678ff4d4687.png";